import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const DashboardSummarySparkleIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('#11349C', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M2.08333 0.75V3.41667M0.75 2.08333H3.41667M2.75 10.0833V12.75M1.41667 11.4167H4.08333M7.41667 0.75L8.94067 5.32133L12.75 6.75L8.94067 8.17867L7.41667 12.75L5.89267 8.17867L2.08333 6.75L5.89267 5.32133L7.41667 0.75Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const DashboardSummarySparkleIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...(props.svg ?? {})}
    >
      <DashboardSummarySparkleIconGroup {...props} />
    </svg>
  );
};
